exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tbody tr {\r\n    cursor: pointer;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/fraud-reports/fraud-reports-table.css
// module id = 979
// module chunks = 0